import React from 'react';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import CheckIcon from '@wix/da-ds/pkg/Icons/24x24/Check';

interface Props {}

const GroupMemberButton: React.FC<Props> = () => {
  return (
    <SolidButton
      variant="approval-green"
      size="large"
      disabled
      icon={CheckIcon}
    >
      Member
    </SolidButton>
  );
};
GroupMemberButton.displayName = 'GroupMemberButton';

export default GroupMemberButton;
